import { IServiceInfo, IServiceInfoDetail } from 'src/app/models';
import { IPagination } from '../states';
import { IServicesInfoDetailsState, IServicesInfosState } from '../states/service-infos';
import { Colors, SortCriteria } from 'src/app/models/enums';

export const initialServiceInfosState: IServicesInfosState = {
  value: [] as IServiceInfo[],
  isFetchingServiceInfos: true,
  pagination: {} as IPagination,
};

export const initialServiceInfoDetailsState: IServicesInfoDetailsState = {
  value: [] as IServiceInfoDetail[],
  isFetchingServiceInfos: true,
  pagination: {} as IPagination,
};

export function initialServiceInfoCreate(): IServiceInfoDetail {
  return {
    backwardsDirection: '',
    color: Colors.NONE,
    forwardDirection: '',
    managerClient: undefined,
    showRealTimes: false,
    showTheoreticalTimes: false,
    sortCriteria: SortCriteria.ALPHABETICALLY,
    serviceType: undefined,
    bookingTimePicker: true,
    tag: '',
    name: '',
    clients: [],
    towns: [],
    clientId: 0,
    townId: 0,
    roundTrips: false,
    // dependentUsers: false,
    // bookingWebsockets: false,
    // bookingQueues: false,
    addressSearch: false
  };
}
